const _excluded = ["links", "custom"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;} /* eslint-disable max-statements */
/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useLoaderData, useRevalidator } from 'react-router';
import { useForm } from 'react-hook-form';
import { useSetAtom } from 'jotai';
import { isUndefined } from 'lodash';
import { Tooltip } from 'flowbite-react';
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import * as SettingsAPI from "../../../api/settings";
import * as TemplatesAPI from "../../../api/templates";
import { notificationAtom } from "../../../atoms";
import { InputField, Select, MultiSelect, Geolocation } from "../../../Components/Forms";
import { Button, Card } from "../../../Components/UI";
import { settingsAtom } from "../../../atoms/settingsAtom";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Translate, t } from "../../../../I18N";

import { FetchResponseError } from "../../../../../shared/JSONRequest";
import * as tips from "./collectionSettingsTips";
import { CollectionOptionToggle } from "./CollectionOptionToggle";

const collectionLoader =
(headers) =>
async () => {
  const settings = await SettingsAPI.get(headers);
  const templates = await TemplatesAPI.get(headers);
  return { settings, templates };
};

const dateOptions = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  const yearLabel = t('System', 'Year', null, false);
  const monthLabel = t('System', 'Month', null, false);
  const dayLabel = t('System', 'Day', null, false);

  return [
  {
    value: 'yyyy/MM/dd',
    label: `${year}/${month}/${day} (${yearLabel}/${monthLabel}/${dayLabel})`
  },
  {
    value: 'dd/MM/yyyy',
    label: `${day}/${month}/${year} (${dayLabel}/${monthLabel}/${yearLabel})`
  },
  {
    value: 'MM/dd/yyyy',
    label: `${month}/${day}/${year} (${monthLabel}/${dayLabel}/${yearLabel})`
  },
  {
    value: 'yyyy-MM-dd',
    label: `${year}-${month}-${day} (${yearLabel}-${monthLabel}-${dayLabel})`
  },
  {
    value: 'dd-MM-yyyy',
    label: `${day}-${month}-${year} (${dayLabel}-${monthLabel}-${yearLabel})`
  },
  {
    value: 'MM-dd-yyyy',
    label: `${month}-${day}-${year} (${monthLabel}-${dayLabel}-${yearLabel})`
  }];

};

const Collection = () => {var _settings$features, _settings$features$oc, _settings$mapLayers, _watch$, _watch;
  const { settings, templates } = useLoaderData();



  const { links, custom } = settings,formData = _objectWithoutProperties(settings, _excluded);

  const setNotifications = useSetAtom(notificationAtom);
  const setSettings = useSetAtom(settingsAtom);
  const revalidator = useRevalidator();
  formData.private = !formData.private;
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({
    defaultValues: formData,
    mode: 'onSubmit'
  });

  const submit = async (data) => {
    if (!isUndefined(data.newNameGeneration) && !data.newNameGeneration) {
      delete data.newNameGeneration;
    }
    data.private = !data.private;
    const response = await SettingsAPI.save(data);
    if (response instanceof FetchResponseError) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: response.message || undefined
      });
    } else {
      setSettings(response);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Settings updated")
      });
    }
    await revalidator.revalidate();
  };

  const labelWithTip = (label, tip) => /*#__PURE__*/
  _jsx("span", { className: "flex gap-4" }, void 0,
  label, /*#__PURE__*/
  _jsx(Tooltip
  // eslint-disable-next-line react/style-prop-object
  , { style: "light",
    content: tip,
    placement: "right" }, void 0, /*#__PURE__*/

  _jsx(QuestionMarkCircleIcon, { className: "w-5 h-5 text-gray-500" })
  )
  );


  const templateOptions = templates.map((template) => ({
    label: template.name,
    value: template._id
  }));

  const mapLayersOptions = [
  { label: 'Dark', value: 'Dark' },
  {
    label: 'Streets',
    value: 'Streets'
  },
  {
    label: 'Satellite',
    value: 'Satellite'
  },
  {
    label: 'Hybrid',
    value: 'Hybrid'
  }];


  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-collection" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Collection" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(submit), id: "collection-form" }, void 0, /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "General") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "collection-name",
      hasErrors: !!errors.site_name,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Collection Name") },
    register('site_name', { required: true }))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "favicon",
      type: "text",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Custom Favicon") },
    register('favicon'))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(Select, _extends({
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Default View"),
      id: "roles",
      options: [
      { label: 'Cards', value: 'cards' },
      { label: 'Map', value: 'map' },
      { label: 'Table', value: 'table' }] },

    register('defaultLibraryView'))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(Select, _extends({
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Default date format"),
      id: "date-format",
      options: dateOptions() },
    register('dateFormat'))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-2" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "landing-page",
      preText: "eg. https://yourdomain",
      label: labelWithTip('Custom landing page', tips.landingPageTip) },
    register('home_page'))
    )
    ), /*#__PURE__*/
    _jsx(CollectionOptionToggle, {
      valueKey: "private",
      label: "Public instance",
      tip: tips.publicSharing,
      register: register,
      defaultChecked: formData.private }
    ), /*#__PURE__*/
    _jsx(CollectionOptionToggle, {
      valueKey: "cookiepolicy",
      label: "Show cookie policy",
      tip: tips.cookiePolicy,
      register: register,
      defaultChecked: formData.cookiepolicy }
    ), /*#__PURE__*/
    _jsx(CollectionOptionToggle, {
      valueKey: "allowcustomJS",
      label: "Global JS",
      tip: tips.globalJS,
      register: register,
      defaultChecked: formData.allowcustomJS }
    ),
    !settings.newNameGeneration && /*#__PURE__*/
    _jsx(CollectionOptionToggle, {
      valueKey: "newNameGeneration",
      label: "Non-latin characters support",
      tip: tips.characterSupport,
      register: register,
      defaultChecked: formData.newNameGeneration }
    )

    )
    ), /*#__PURE__*/
    _jsx(Card, {
      className: "mb-4",
      title: /*#__PURE__*/
      _jsx("span", { className: "flex gap-4" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Analytics"), /*#__PURE__*/
      _jsx(Tooltip
      // eslint-disable-next-line react/style-prop-object
      , { style: "light",
        content: tips.analytics,
        placement: "right" }, void 0, /*#__PURE__*/

      _jsx(QuestionMarkCircleIcon, { className: "w-5 h-5 text-gray-500" })
      )
      ) }, void 0, /*#__PURE__*/


    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "google-analytics",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Google") },
    register('analyticsTrackingId'))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "matomo-analytics",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Matomo") },
    register('matomoConfig'))
    )
    )
    )
    ),
    ((_settings$features = settings.features) === null || _settings$features === void 0 ? void 0 : (_settings$features$oc = _settings$features.ocr) === null || _settings$features$oc === void 0 ? void 0 : _settings$features$oc.url) && /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Services") }, void 0, /*#__PURE__*/
    _jsx(CollectionOptionToggle, {
      valueKey: "ocrServiceEnabled",
      label: "Document OCR trigger",
      tip: tips.ocrTrigger,
      register: register,
      defaultChecked: formData.ocrServiceEnabled }
    )
    ), /*#__PURE__*/

    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Forms and email configuration") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "sending-email",
      label: labelWithTip('Sending email', tips.emails[1]) },
    register('senderEmail'))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "receiving-email",
      label: labelWithTip('Contact form email', tips.receivingEmail) },
    register('contactEmail'))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-2" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "public-form-destination",
      label: labelWithTip('Public Form submit URL', tips.publicForm[1]) },
    register('publicFormDestination'))
    )
    ), /*#__PURE__*/
    _jsx(CollectionOptionToggle, {
      valueKey: "openPublicEndpoint",
      label: "Allow captcha bypass",
      tip: tips.openPublicForm,
      register: register,
      defaultChecked: formData.openPublicEndpoint }
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-2" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      label: labelWithTip('Whitelisted templates', tips.publicForm[2]),
      options: templateOptions,
      onChange: (newValues) => {
        setValue('allowedPublicTemplates', newValues);
      },
      value: settings.allowedPublicTemplates || [] }
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Map") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(Select, _extends({
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Map Provider"),
      id: "roles",
      options: [
      { label: 'Mapbox', value: 'mapbox' },
      { label: 'Google', value: 'google' }] },

    register('tilesProvider'))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "map-key",
      label: labelWithTip('Map API key', tips.mapApiKey) },
    register('mapApiKey', { pattern: /^[a-zA-Z0-9._]+$/ }))
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-2" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      label: labelWithTip('Map Layers', tips.mapLayers),
      options: mapLayersOptions,
      hasErrors: !!errors.mapLayers,
      canBeEmpty: false,
      value: (_settings$mapLayers = settings.mapLayers) !== null && _settings$mapLayers !== void 0 && _settings$mapLayers.length ? settings.mapLayers : ['Streets'],
      onChange: (newValues) => {
        clearErrors('mapLayers');
        if (!newValues.length) {
          setError(
            'mapLayers',
            { type: 'custom', message: 'Map layers cannot be empty' },
            { shouldFocus: true }
          );
          return;
        }
        //@ts-ignore
        setValue('mapLayers', newValues);
      } }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "col-span-2" }, void 0, /*#__PURE__*/
    _jsx(Geolocation, {
      value: (_watch$ = (_watch = watch('mapStartingPoint')) === null || _watch === void 0 ? void 0 : _watch[0]) !== null && _watch$ !== void 0 ? _watch$ : {},
      onChange: ({ lat, lon }) => {
        if (lat && lon) {
          setValue('mapStartingPoint', [{ lat, lon }]);
          return;
        }
        setValue('mapStartingPoint', []);
      },
      name: "mapStartingPoint" }
    )
    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "submit", form: "collection-form" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    )
    ));

};

export { Collection, collectionLoader };